import {Action} from "@dp-instant/core";
import {inject, injectable} from "inversify";
import {Vector2} from "@game/coregame/interfaces/Vector2";
import svgPathBbox from "svg-path-bbox";
import {SCALE_MODES, Sprite, Texture} from "pixi.js-legacy";
import {Types2D} from "@dp-instant/interfaces";
import {RootView} from "@dp-instant/2d";
import {SpritesPool} from "@game/coregame/utils/SpritesPool";
import {TypesGame} from "@game/TypesGame";

type CreateMapShape = {
    id: string;
    shapes?: string[];
    keepCache?: boolean;
};
@injectable()
export class GenerateMapShapeAction extends Action<CreateMapShape, Sprite> {
    @inject(Types2D.rootView)
    protected rootView: RootView;

    @inject(TypesGame.spritesPool)
    protected spritesPool: SpritesPool;

    async execute(payload: CreateMapShape): Promise<Sprite> {
        const shapes = payload.shapes;
        const keepCache = typeof payload.keepCache == "undefined" ? true : payload.keepCache;
        if (shapes?.length) {
            let tx = Infinity,
                ty = Infinity;
            const positions: Vector2[] = [];
            const sprites = await Promise.all(
                shapes.map(async (shape, index) => {
                    const [x, y] = svgPathBbox(shape);
                    tx = Math.min(tx, x);
                    ty = Math.min(ty, y);
                    const sprite = await this.spritesPool.createShape(
                        `${payload.id}${index > 0 ? index : ""}`,
                        shape,
                        keepCache
                    );
                    positions.push([x, y]);
                    return sprite;
                }) || []
            );

            const cont = new Sprite();

            sprites.forEach((sprite, i) => {
                const position = positions[i];
                const [x, y] = position;
                sprite.position.set(x - tx, y - ty);
                cont.addChild(sprite);
            });

            const texture = this.rootView.app.renderer.generateTexture(
                cont,
                SCALE_MODES.LINEAR,
                window.devicePixelRatio
            );
            const sprite = new Sprite(texture);
            sprite.position.set(tx, ty);
            !keepCache && sprites.forEach(s => Texture.removeFromCache(s.texture));
            Texture.removeFromCache(texture);
            return sprite;
        }
        return new Sprite(Texture.EMPTY);
    }
}
